import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { FooterMedium } from "../../../components/FooterMedium";

import {
  Screen1,
  Problems,
  Program,
  Answers,
  Message,
  Revs,
  Speakers,
  Advance,
  Reg
} from "../../../components/LandingTemplates/nauchite_detey_uchitsya";

const TITLE = 'Бесплатный вебинар для родителей «Научите детей учиться»';
const DESCRIPTION = 'Бесплатный вебинар для родителей «Научите детей учиться»';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget=<GetCourseWidget hash={'3e4b00b611271fc62e6e89bfc292abf8bf983c94'} id={'155732'}/> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 id={'ndu'} widget={widget}/>
      <Problems/>
      <Program/>
      <Answers/>
      <Message/>
      <Revs/>
      <Speakers/>
      <Advance/>
      <Reg widget={widget}/>
    </main>

    <FooterMedium/>

  </DefaultLayout>
);
export default Page;
